// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "军事理论",
      "tec": "于修理",
      "week": "8-16周",
      "add": "教学楼B座422能动"
    },
    {
      "sub": "计算机科学导论",
      "tec": "郝雪燕",
      "week": "6,8-17单周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "高级语言程序设计",
      "tec": "张欣",
      "week": "6,8-18周",
      "add": "实训楼F座303信息"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "就业创业指导",
      "tec": "关颖",
      "week": "8-12周",
      "add": "教学楼B座421能动"
    },
    {
      "sub": "高等数学（一）",
      "tec": "赵丹",
      "week": "6,8-18周",
      "add": "实训楼F座103自控"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26计理1-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26计理2-2",
        "tec": "王国志",
        "week": "6-17周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "26计理1-2",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "实训楼E座310"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    0
  ],
  "3": [
    {
      "sub": "高等数学（一）",
      "tec": "赵丹",
      "week": "6,8-18周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "高级语言程序设计",
      "tec": "张欣",
      "week": "6,8-18周",
      "add": "教学楼B座221自控"
    },
    0,
    [
      {
        "sub": "健康教育",
        "tec": "韩吉哲",
        "week": "6-10,12-17周",
        "add": "教学楼C座306教务"
      },
      {
        "sub": "健康教育",
        "tec": "韩吉哲",
        "week": "11周",
        "add": "教学楼C座306教务"
      },
      {
        "sub": "健康教育",
        "tec": "韩吉哲",
        "week": "11周",
        "add": "教学楼C座306教务"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "张梦琪",
      "week": "6,8-10周",
      "add": "教学楼C座113教务"
    }
  ],
  "4": [
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "26计理2-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "教学楼A座126信息"
      },
      {
        "sub": "26计理1-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "教学楼A座125信息"
      },
      {
        "sub": "26计理1-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "教学楼A座122信息"
      }
    ],
    {
      "sub": "心理健康与调适",
      "tec": "李婵",
      "week": "6,8-16周",
      "add": "教学楼A座125信息"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "赵丹",
      "week": "6,8-18周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "计算机科学导论",
      "tec": "郝雪燕",
      "week": "6,8-17周",
      "add": "实训楼F座102自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
